import { immerable } from "immer";

import { PlaceCategory } from "modules/customer/tools/location/placeCategory";

export class CompetitorStoreCategory extends PlaceCategory {
    [immerable] = true;

    public readonly isPrimary: boolean;
    private _isSelected: boolean;

    constructor(
        placeCategory: PlaceCategory,
        isPrimary: boolean,
        _isSelected: boolean
    ) {
        super(
            placeCategory.id,
            placeCategory.name,
            placeCategory.superCategoryName,
            placeCategory.isDestination,
            placeCategory.isRetailer,
            placeCategory.indirectlyCompetingCategories
        );
        this.isPrimary = isPrimary;
        this._isSelected = _isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }

    getLabel(): string {
        return `${this.name} (${this.isPrimary ? "Primary" : "Secondary"} category)`;
    }
}
